import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Toolbar, useMediaQuery } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import navigation from 'menu-items';
import Breadcrumbs from 'components/@extended/Breadcrumbs';

// types
import { openDrawer } from 'store/reducers/menu';
import CustomizedDialogs from '../../components/CustomizedDialogs';
import { me } from '../../store/reducers/auth';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
  const dispatch = useDispatch();
  const location = useLocation();
  const [isAllowed, setIsAllowed] = useState(false);

  const fetchingMe = useSelector((state) => state.auth.fetchingMe);
  const meData = useSelector((state) => state.auth.me);

  const { drawerOpen } = useSelector((state) => state.menu);

  // drawer toggler
  const [open, setOpen] = useState(drawerOpen);
  const handleDrawerToggle = () => {
    setOpen(!open);
    dispatch(openDrawer({ drawerOpen: !open }));
  };

  // set media wise responsive drawer
  useEffect(() => {
    setOpen(!matchDownLG);
    dispatch(openDrawer({ drawerOpen: !matchDownLG }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownLG]);

  useEffect(() => {
    if (open !== drawerOpen) setOpen(drawerOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerOpen]);

  useEffect(() => {
    dispatch(me());
  }, []);

  useEffect(() => {
    setIsAllowed(false);
    if (meData) {
      const isAllowed = meData.permissions.find((permission) => permission.route === location.pathname);
      setIsAllowed(!!isAllowed);
    }
  }, [meData, location]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      {fetchingMe || !meData ? null : (
        <>
          <Header open={open} handleDrawerToggle={handleDrawerToggle} />
          <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
          <Box component="main" sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
            <Toolbar />

            {isAllowed ? (
              <>
                <Breadcrumbs navigation={navigation} title titleBottom card={false} divider={false} />
                <Outlet />
              </>
            ) : null}
          </Box>
        </>
      )}

      <CustomizedDialogs />
    </Box>
  );
};

export default MainLayout;
